<style scoped>
    .demo-drawer-footer{
        width: 400px;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
</style>
<template>
    <div>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">

            <!--<Steps style="margin-left:10px; margin-top: 20px" :current="current">-->
                <!--<Step @click.native="current = 0" title="选择分类"><div></div></Step>-->
                <!--<Step @click.native="current = 1" title="设置名称"></Step>-->
            <!--</Steps>-->

            <!--选择类型-->
            <!--<div v-show="current == 0" style="margin-top: 30px;">-->
                <!--<ul class="select-type">-->
                    <!--<li @click="formValidate.sbtype = 1;formValidate.title= '灯具';current = 1" :class="[formValidate.sbtype == 1 ? 'active' : '']">-->
                        <!--<div><img :src="dj" alt=""><p>灯具</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 2;formValidate.title= '水泵';current = 1" :class="[formValidate.sbtype == 2 ? 'active' : '']">-->
                        <!--<div><img :src="sb" alt=""><p>水泵</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 3;formValidate.title= '电磁阀';current = 1" :class="[formValidate.sbtype == 3 ? 'active' : '']">-->
                        <!--<div><img :src="dcf" alt=""><p>电磁阀</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 4;formValidate.title= '无线控制柜';current = 1" :class="[formValidate.sbtype == 4 ? 'active' : '']">-->
                        <!--<div><img :src="wxkzg" alt=""><p>无线控制柜</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 5;formValidate.title= '智能面板';current = 1" :class="[formValidate.sbtype == 5 ? 'active' : '']">-->
                        <!--<div><img :src="znmb" alt=""><p>智能面板</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 6;formValidate.title= '传感器';current = 1" :class="[formValidate.sbtype == 6 ? 'active' : '']">-->
                        <!--<div><img :src="cgq" alt=""><p>传感器</p></div>-->
                    <!--</li>-->
                    <!--<li @click="formValidate.sbtype = 7;formValidate.title= '摄像头';current = 1" :class="[formValidate.sbtype == 7 ? 'active' : '']">-->
                        <!--<div><img :src="sxt" alt=""><p>摄像头</p></div>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->

            <FormItem label="选择分类" prop="sbtype">
                <Select v-model="formValidate.sbtype" label-in-value @on-change="onSelect" style="width:100%">
                    <Option v-for="item in list" :value="item.catId" :key="item.value">{{ item.catName }}</Option>
                </Select>
            </FormItem>

            <!--设置场景-->
            <div style="margin-top: 30px;">
                <FormItem label="分类名称" prop="title">
                    <Input :maxlength="10" v-model="formValidate.title" clearable placeholder="请输入分类名称"></Input>
                </FormItem>
            </div>

            <!--按钮-->
            <div class="demo-drawer-footer">
                <Button style="margin-right: 8px" @click="onCancel">取消</Button>
                <Button type="primary" :loading="formValidate.btnLoading" @click="handleSubmit('formValidate')">{{!formValidate.btnLoading ? '确定' : '提交中...'}}</Button>
            </div>
        </Form>
    </div>
</template>

<script>
    import dj    from '@/assets/img/lx/dj.png';
    import sb    from '@/assets/img/lx/sb.png';
    import dcf   from '@/assets/img/lx/dcf.png';
    import wxkzg from '@/assets/img/lx/wxkzg.png';
    import znmb  from '@/assets/img/lx/znmb.png';
    import cgq   from '@/assets/img/lx/cgq.png';
    import sxt   from '@/assets/img/lx/sxt.png';

    export default {
        name: "dscj-add",
        data() {
            return {
                //图片
                dj:dj,
                sb:sb,
                dcf:dcf,
                wxkzg:wxkzg,
                znmb:znmb,
                cgq:cgq,
                sxt:sxt,

                //索引
                current:0,

                list:[],

                //表单
                formValidate: {
                    title: '',
                    sbtype:'',
                    btnLoading:false
                },
                ruleValidate: {
                    sbtype: [
                        {required: true, message: "请选择分类", trigger: "change" }
                    ],
                    title: [
                        { required: true, message: '分类名称不能为空', trigger: 'change' }
                    ],
                },

            };
        },
        created(){
            this.getCategory();
        },
        methods: {
            onSelect(val){
                this.formValidate.title = val.label;
            },
            getCategory(){
                const that = this;
                that.$func.ajax('catList',{
                    catPosition:2,
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.list = r.type;
                    }
                })
            },
            onCancel(){
                this.$emit('close');
            },
            // +---------------
            // | 提交表单
            // +---------------
            handleSubmit(name) {
                const that = this;
                //验证表单
                that.$refs[name].validate(valid => {
                    if (valid)
                    {
                        that.$func.ajax('customerCatSave',{
                            catId:that[name].sbtype,
                            catSelfName:that[name].title,
                            token:that.$func.getToken()
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$func.msg('添加成功');
                                //按钮状态关闭
                                that.$refs[name].resetFields();
                                that[name].btnLoading = false;
                                that.onCancel();
                                //提示更新
                                that.$emit('refresh')
                            }
                        })
                    }
                });
            }
        }
    };
</script>